export enum AuthorizationType {
  Page = 'Page',
  Hidden = 'Hidden',
  Disabled = 'Disabled',
  Feature = 'Feature',
}

export enum SystemRoleType {
  Admin = 'admin',
}

export type Role = {
  id: number
  name: string
  description: string
  clientId: number
  type: number
}

export type RolesObject = {
  system?: Role[]
  boat: Role[]
  client: Role[]
}

export type FunctionElement = {
  name: string
  permissions: string[]
  accessLevels: any
}

export type FunctionElementsObject = {
  boatFunctionElements: FunctionElement[]
  boatListFunctionElements: FunctionElement[]
}

export type AccessLevels = {
  isDisabled?: boolean
  roleId: number
  clientUserLinkId: number
}
